import { FC } from 'react';
import { ButtonRow } from '../ButtonRow';
import { BBButtonContainerMarginBtm, BBOuter, ModalHeader } from '../styles';
import { useTranslations } from 'next-intl';

interface BedsBathsSectionProps {
  bedrooms: { title: string; value: number | null }[];
  bathrooms: { title: string; value: number }[];
  bedsValue?: number | null;
  bathsValue?: number | null;
  onBedsChange: (value: number | null) => void;
  onBathroomsChange: (value: number | null) => void;
}

export const BedsBathsSection: FC<BedsBathsSectionProps> = ({
  bedrooms,
  bathrooms,
  bedsValue,
  bathsValue,
  onBathroomsChange,
  onBedsChange,
}) => {
  const t = useTranslations();
  return (
    <BBOuter>
      <BBButtonContainerMarginBtm>
        <ModalHeader data-testid="bedrooms-header">{t('Bedrooms')}</ModalHeader>

        {bedrooms && (
          <ButtonRow
            testIdType="bed"
            buttons={bedrooms}
            value={bedsValue}
            onChange={onBedsChange}
          />
        )}
      </BBButtonContainerMarginBtm>
      <ModalHeader data-testid="bathrooms-header">{t('Bathrooms')}</ModalHeader>
      {bathrooms && (
        <ButtonRow
          testIdType="bath"
          buttons={bathrooms}
          value={bathsValue}
          onChange={onBathroomsChange}
        />
      )}
    </BBOuter>
  );
};
